// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"Nav_navWrapper__302A2","nav":"Nav_nav__-S9dB","joinUs":"Nav_joinUs__25znw","socials":"Nav_socials__16hYf"};